import { Component, OnInit, Inject, ViewEncapsulation, Optional } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from 'src/app/api.service';

export interface DialogData {
  animal: string;
  name: string;
}

@Component({
  selector: 'app-create-bm-dialog',
  templateUrl: './create-bm-dialog.component.html',
  styleUrls: ['./create-bm-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreateBmDialogComponent implements OnInit {
  showSpinner = false;
  newBoardMemberData = new FormGroup({
    firstName: new FormControl('', Validators.required),
    lastName: new FormControl('', Validators.required),
    email: new FormControl('', [Validators.required, Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/)]),
    phone: new FormControl('', [Validators.required, Validators.pattern(/^\d{10}$/)])
  });
  phoneNumberEntered = new FormGroup({
    phone: new FormControl('', [Validators.required])
  });
  users = [];
  matched = true;
  fitlered_user :any = {}
  boardMemberList = [];
  filterUserWithoutBM = [] ;

  // displayedColumns = ['first_name','phone', 'id'];
  displayedColumns = ['first_name','division','phone', 'id'];
  dataSource;
  start: number = 0;
  limit: number = 10;
  end: number = this.limit + this.start;
  selectedRowIndex: number = null;

  constructor(
    public dialogRef: MatDialogRef<CreateBmDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar
  ) {
    this.boardMemberList = data.boardMemberList;
    console.log(this.boardMemberList);
  }
 
  ngOnInit(): void {
    let data = {"roles":[]};
    this.showSpinner = true;
    this._apiService.getUserList(data).subscribe(res => {
      if (res) {
        this.users = res;
        this.filterUserWithoutBM = []
        for(let i=0; i<this.users.length; i++){
          
          if(this.boardMemberList.filter(e => e.phone === this.users[i].phone).length == 0){
            this.filterUserWithoutBM.push(this.users[i]);
          }
        }
        // debugger;
        this.fitlered_user = this.filterUserWithoutBM.slice(0, 5);
        this.dataSource = this.getTableData(0, this.end);
        this.updateIndex();
        this.showSpinner = false;
        console.log(this.users);
      }
    },
    (error)=>{
      this.showSpinner = false;
    });

    
    // this.dataSource = this.getTableData(this.start, this.end);
    
  }

  close(): void {
    this.dialogRef.close();
  }

  onPhoneNochange(event){
    let fitlered_users = this.filterUserWithoutBM.filter(ele => ele.phone.includes(event));
      this.fitlered_user = fitlered_users.slice(0, 5);
      if (fitlered_users.length>0) {
      this.matched = true
      }else {
      this.matched = false
      }
  }
  

  // save(){
  //   if (this.newBoardMemberData.valid) {
  //     const BoardMemberData = {
  //       ...this.newBoardMemberData.value,
  //     }
  //     console.log(BoardMemberData);

  //   }
  // }

  createBoardMember(userData){
    if (this.boardMemberList.filter(e => e.phone === userData.phone).length == 0) {
      debugger;
      let bmInfo = {
        "user_id":userData.id,
        "name":userData.first_name +' '+userData.last_name,
        "phone":userData.phone,
        "group_id":[],
        "division":userData.division
      }
      this.showSpinner = true;
      this._apiService.createBoardMember(bmInfo).subscribe(res => {
        if (res) {
          this.dialogRef.close();
          this.showSpinner = false;
          console.log(res);
        }
      },
      (error)=>{
        this.showSpinner = false;
      });
    }else{
      this._snackBar.open('Board Member Already Exists', 'OK', { duration: 3000 })
    }
    
  }

  onTableScroll(e) {
    // debugger;
    console.log(e)
    const tableViewHeight = e.target.offsetHeight // viewport
    const tableScrollHeight = e.target.scrollHeight // length of all table
    const scrollLocation = e.target.scrollTop; // how far user scrolled
    
    // If the user has scrolled within 200px of the bottom, add more data
    const buffer = 200;
    const limit = tableScrollHeight - tableViewHeight - buffer;    
    if (scrollLocation > limit) {
      let data = this.getTableData(this.start, this.end);;
      this.dataSource = this.dataSource.concat(data);
      this.updateIndex();
    }
  }

  getTableData(start, end) {
    // debugger
    console.log(this.filterUserWithoutBM)
    return this.filterUserWithoutBM.filter((value, index) => index >= start && index < end)
  }
  updateIndex() {
    this.start = this.end;
    this.end = this.limit + this.start;
  }

  selectedRow(row) {
    console.log('selectedRow', row)
  }

  

  

}
